<template>
<div id="conactus">
  <div class="introTitle" v-show="isShow">
    联系我们
  </div>
  <el-row :gutter="50">
    <el-col :span="12">
      <i class="el-icon-qq">QQ</i>
      <span>1669378879</span>
    </el-col>
    <el-col :span="12">
      <i class="el-icon-message"></i>
      <span>
        haigang_sui@263.net
      </span>
    </el-col>
  </el-row>
  <el-row :gutter="50">
    <el-col :span="12">
      <i class="el-icon-coordinate"></i>
      <span>湖北省武汉市珞喻路129号</span>
    </el-col>
    <el-col :span="12">
      <i class="el-icon-box"></i>
      <span>
        430079
      </span>
    </el-col>
  </el-row>
  <div id="mapContainer">
  </div>
</div>
</template>

<script>
import mapboxgl from "mapbox-gl"
export default {
  name: "ConactUs",
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    this.isShow = this.$route.query.isShow
    console.log(this.isShow)
    this.initMap()
  },
  methods: {
    initMap(){
      mapboxgl.accessToken = 'pk.eyJ1Ijoib3Jhbmdlci1tYXAiLCJhIjoiY2p4ZWVzMjQ0MGFoejN6cGJrYndwbjd1biJ9.4lMF1awaanfMIbiuB852vw';
      var map = new mapboxgl.Map({
        container: 'mapContainer', // container id
        style: 'mapbox://styles/mapbox/streets-v11', // style URL
        center: [114.3548, 30.5294], // starting position [lng, lat]
        pitch: 45,
        zoom: 15, // starting zoom
        attributionControl: false
      });
      new mapboxgl.Marker()
          .setLngLat([114.3548, 30.5294])
          .addTo(map);
    }
  }
}
</script>

<style lang="less">
#conactus {
  margin-bottom: 20px;
  .introTitle{
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    font-weight: bolder;
    color: #076498;
    border-bottom: 1px solid #b1b1b1;
  }
  .el-row{
    padding: 20px;
    .el-col{
      padding: 10px;
      .el-icon-qq, .el-icon-message, .el-icon-box, .el-icon-coordinate{
        color: #b8029a;
        font-size: 40px;
      }
      span{
        padding: 5px;
        color: #4f4f4f;
        font-size: 18px;
      }
    }
  }
  #mapContainer {
    height: 500px;
    //.mapboxgl-control-container
    .mapboxgl-ctrl-bottom-left{
      .mapboxgl-ctrl-logo{
        display: none;
      }
    }
  }
}
</style>
